// src/ProtectedRoute.jsx
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { isAuthenticated, user, isLoading } = useAuth();
  const location = useLocation();
  const [ok, setOk] = useState(null);
  const [denyReason, setDenyReason] = useState(null);

  useEffect(() => {
    if (isLoading) {
      setOk(null); // Still loading
      return;
    }

    if (!isAuthenticated) {
      setDenyReason('unauthenticated');
      setOk(false);
      return;
    }

    if (!user) {
      setOk(null);
      return;
    }

    if (role) {
      const userRole = user?.role ?? user?.user?.role ?? 'client';
      if (userRole !== role) {
        setDenyReason('role');
        setOk(false);
        return;
      }
    }

    setDenyReason(null);
    setOk(true);
  }, [isAuthenticated, user, role, isLoading]);

  if (ok === null) {
    return (
      <div role="status" style={{ padding: '2rem', textAlign: 'center' }}>
        Checking session…
      </div>
    );
  }
  if (ok) return children;

  if (denyReason === 'unauthenticated') {
    const next = `${location.pathname}${location.search || ''}`;
    return <Navigate to={`/login?redirect=${encodeURIComponent(next)}`} replace />;
  }

  return <Navigate to="/login" replace />;
}
